import { WORKING_UNIT_THICKNESS } from 'features/indicationTriage/cards/ffsCalc/ffsUnits'
import _ from 'lodash'
import { useMemo } from 'react'
import { GeckoMeasurement, GeckoMeasurementUnit } from 'types'

type HookProps = {
  tmm: GeckoMeasurement | null
  fcaMl: GeckoMeasurement | null
  tc: GeckoMeasurement | null
  fca: GeckoMeasurement | null
  mt: GeckoMeasurement | null
}

export function useRsfValues({ tmm, fcaMl, tc, fca, mt }: HookProps): {
  rsf: GeckoMeasurement | null
  rt: GeckoMeasurement | null
} {
  const remainingThicknessRatio = useMemo(
    () =>
      _.isNil(tmm) || _.isNil(fcaMl) || _.isNil(tc) || _.isNil(fca)
        ? null
        : GeckoMeasurement.CreateFromValue(
            (tmm.convertTo(WORKING_UNIT_THICKNESS).num -
              fcaMl.convertTo(WORKING_UNIT_THICKNESS).num) /
              tc.convertTo(WORKING_UNIT_THICKNESS).num,
            GeckoMeasurementUnit.Ratio
          ),
    [tc, fca, fcaMl, tmm]
  )
  const rsfNum =
    remainingThicknessRatio && mt
      ? calculateRSF(remainingThicknessRatio?.num, mt.num)
      : null
  const rsf = !_.isNil(rsfNum)
    ? GeckoMeasurement.CreateFromValue(rsfNum, GeckoMeasurementUnit.Ratio)
    : null
  return {
    rt: remainingThicknessRatio,
    rsf,
  }
}

function calculateRSF(rt: number, mt: number): number | null {
  // Check for invalid input values
  if (mt === 0 || mt - (1 - rt) === 0) {
    return null // Return null for invalid cases
  }

  // Simplified calculation
  const rsf = (rt * mt) / (mt - (1 - rt))
  return rsf
}
